import { Component } from '@angular/core';

@Component({
  selector: 'app-split-chip-filter',
  templateUrl: './split-chip-filter.component.html',
  styleUrls: ['./split-chip-filter.component.scss']
})
export class SplitChipFilterComponent {

}
